<div class="wrapper-notifications" (scroll)="onScroll($event)">
  <div class="wrapper-notification" *ngFor="let notification of notifications" (click)="clickOnNotification(notification)" [ngClass]="{'unread': notification.read_at === null}">
    <span class="title-notification">{{ notification.data.data.title }}</span>
    <span class="description-notification">{{ notification.data.data.description }}</span>
    <span class="time-notification">{{ notification.data.created_at | timeAgo }}</span>
  </div>
</div>
